import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { Button, Card, Col, Form, Modal, Row, Table } from "antd"
import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import { FileExcelFilled } from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel"
import { StockInService } from "@gtpl/shared-services/warehouse-management";
import { StockExcelUploadReq } from "@gtpl/shared-models/warehouse-management";
import moment from "moment";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { JsonObjectreq } from "@gtpl/shared-models/production-management";

export const StockExcelUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const history = useHistory()
    const [data, setData] = useState()
    const [columns, setColumns] = useState([]);
    const [values, setValues] = useState([])
    const createdUser= localStorage.getItem("createdUser");
    const stockService = new StockInService()
    const [notSavedRecords,setNotSavedRecords] = useState<any[]>([])
    const [modalVisible,setModalVisible] = useState<boolean>(false)
    const [sampleFormatData,setSampleFormatData] = useState<any[]>([{
      "SNO" :1,
      "Unit" : "",
      "Date"  : "2024-01-01",
      "TrasacionType" : "fresh production",
      "JobCode" : "",
      "StockType" : "Dummy",
      "CustomerPo" : "PO001",
      "LotCode" : "Lot001",
      "Product" : "HLSO-BLOCK-26/30",
      "PackStyle" : "1x10 lb",
      "Cartons" : 5,
      "LoosePouches" : 3,
      "Shift" : "Day",
      "Freezer" : "IQF",
      "WHIncharge" : "Sai",
      "RackPosition" : "Rack1",
      "ProductCategory" : "GI",
      "JobCompleted" : ""
  }])


    const importExcel = (file: any[]) => {
        var data = new Uint8Array(file);
        var wb = XLSX.read(data, { type: 'array', cellDates: true });
        let sheet: any[] = [];
        for (const Sheet in wb.Sheets) {
          if(Sheet){
            if (wb.Sheets.hasOwnProperty(Sheet)) {
                sheet.push(XLSX.utils.sheet_to_json(wb.Sheets[Sheet], { raw: true, header: 1 }));
            }
          }
        }
        return sheet;
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'text/csv') {
          setSelectedFile(event.target.files[0]);
          Papa.parse(event.target.files[0], {
            header: true,
            complete: function (result) {
              {
                const columnArray = [];
                const valueArray = [];
                
                result.data.map((d) => {
                                    columnArray.push(Object.keys(d))
                    valueArray.push(Object.values(d))
                              });
                            setData(result.data)
                setColumns(columnArray[0])
                setValues(valueArray)
              }
            },
            skipEmptyLines: true,
          });
        } else if(file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
          setSelectedFile(event.target.files[0]);
          let csvData
          var reader = new FileReader()
          reader.readAsArrayBuffer(file)
          reader.onload = async data => {
            let csvData1: any = reader.result;
            csvData = importExcel(csvData1);
            // let headersRow = getHeaderArray(csvData[0][3]);
            // csvData[0].shift()
            // csvData[0].shift()
            // csvData[0].shift()
            // console.log(csvData[0],'????????')
            const filteredNestedData = csvData.filter(innerData => innerData.some(row => row.length > 0));
      
            const output = filteredNestedData.map(innerData => {
              const header = innerData[0];
              return innerData.slice(1).map(row => {
                if (row.every(value => value === '')) {
                  return null; // Skip rows with all empty values
                }
                return row.reduce((acc, value, index) => {
                  acc[header[index]] = value;
                  return acc;
                }, {});
              }).filter(row => row !== null); // Remove rows with all empty values
            });  
               setData(output[0])   
          }
        }else {
          alert('Please select a valid .csv file.');
          setSelectedFile(null);
        }
      };


    const handleUpload = () => {
        try{
            form.validateFields().then(() => {
                console.log(data,'==================')
              const req = new StockExcelUploadReq(data,createdUser)
              const jsonObjReq = new JsonObjectreq(JSON.stringify(req))
            stockService.stockExcelUpload(jsonObjReq).then(res => {
              if(res.status){
                setLoading(true);
                if(res.status){
                  AlertMessages.getSuccessMessage(res.internalMessage)
                  setLoading(false)
                  setNotSavedRecords(res.data)
                  if(res.data.length > 0){
                    setModalVisible(true)
                  }
                  // history.push("/fg-stock")
                } else{
                  setLoading(false)
                    AlertMessages.getErrorMessage(res.internalMessage)
                }
              }
            })
            })
        } catch (error) {
            AlertMessages.getErrorMessage(error.message);
          }
    }

    const exceldata = [
        { title: 'SNo', dataIndex: 'sNo', render: (text, object, index) => {  return index+1},width: 60, }, 
        { title: 'Unit', dataIndex: 'Unit'},
        { title: 'Date', dataIndex: 'Date',render:(text,record) => {return(record.Date ? moment(record.Date).format('YYYY-MM-DD') : '')} },
        { title: 'Transaction Type', dataIndex: 'TransactionType'},
        { title: 'Job Code', dataIndex: 'JobCode'},
        { title: 'Stock Type', dataIndex: 'StockType'},
        { title: 'Customer Po', dataIndex: 'CustomerPo'},
        { title: 'Lot Code', dataIndex: 'LotCode' },
        {title:'Grade Change',dataIndex:'GradeChange'},
        {title:'Soaking Product',dataIndex:'SoakingProduct'},
        { title: 'Product', dataIndex: 'Product' },
        { title: 'Pack Style', dataIndex: 'PackStyle' },
        { title: 'Cartons', dataIndex: 'Cartons' },
        { title: 'Loose Pouches', dataIndex: 'LoosePouches' },
        { title: 'Shift', dataIndex: 'Shift' },
        { title: 'Freezer', dataIndex: 'Freezer' },
        { title: 'WH Incharge', dataIndex: 'WHIncharge' },
        { title: 'Rack Position', dataIndex: 'RackPosition' },
        { title: 'Product Category', dataIndex: 'ProductCategory' },
        {title:'Rejection From',dataIndex:'RejectionFrom'},
        {title:'Job Completed',dataIndex:'JobCompleted'},
        {title:'Reason',dataIndex : 'reason'}
        
      
    ]

    const exportExcel = async() => {
        // const excel = new Excel();
        // excel
        //   .addSheet('Stock Excel')
        //   .addColumns(exceldata)
        //   .saveAs('Stock format.xlsx');

          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet("Stock Excel");
      
          // Define columns
          worksheet.columns = exceldata.map(col => ({ header: col.title, key: col.dataIndex, width: 20 }));
      
          // Populate data (Convert date format)
          sampleFormatData.forEach((record, index) => {
              worksheet.addRow({
                  ...record,
                  Date: record.Date ? moment(record.Date).format('YYYY-MM-DD') : '',
                  sNo: index + 1
              });
          });
          // Apply Data Validation
          worksheet.getColumn("TransactionType").eachCell((cell, rowNumber) => {
              if (rowNumber == 2) { // Skip header row
                  cell.dataValidation = {
                      type: "list",
                      allowBlank: false,
                      formulae: ['"Fresh Production,Repacking,Reprocessing,Stock Transfer,Reworking,Purchase Product,Lab Samples,Complements"'] // Modify values as per your requirement
                  };
              }
          });

          worksheet.getColumn("StockType").eachCell((cell, rowNumber) => {
            if (rowNumber == 2) { // Skip header row
                cell.dataValidation = {
                    type: "list",
                    allowBlank: false,
                    formulae: ['"Anticipated,Dummy,Sale Order,Super Dummy"'] // Modify values as per your requirement
                };
            }
        });
      
          worksheet.getColumn("Shift").eachCell((cell, rowNumber) => {
              if (rowNumber == 2) {
                  cell.dataValidation = {
                      type: "list",
                      allowBlank: false,
                      formulae: ['"General,DAY,NIGHT"']
                  };
              }
          });

          worksheet.getColumn("ProductCategory").eachCell((cell, rowNumber) => {
            if (rowNumber == 2) {
                cell.dataValidation = {
                    type: "list",
                    allowBlank: false,
                    formulae: ['"Over Count,Over Count Full Cut,Over Count Pull veined,For Weight,Under Count,Cut,RJ(Rejections),Damaged.P1-D,P2-D,P3-D,P4-D,P5-D,P6-D,Red Spot,Meat,jumble,GI,GII,A/B(REJECTIONS),RRP"']
                };
            }
        });

        worksheet.getColumn("GradeChange").eachCell((cell, rowNumber) => {
          if (rowNumber == 2) { // Skip header row
              cell.dataValidation = {
                  type: "list",
                  allowBlank: false,
                  formulae: ['"YES,NO"'] // Modify values as per your requirement
              };
          }
      });
      
          // worksheet.getColumn("Cartons").eachCell((cell, rowNumber) => {
          //     if (rowNumber !== 1) {
          //         cell.dataValidation = {
          //             type: "whole",
          //             operator: "greaterThanOrEqual",
          //             formulae: ["0"],
          //             showErrorMessage: true,
          //             errorTitle: "Invalid Value",
          //             error: "Cartons must be a positive number"
          //         };
          //     }
          // });
      
          // Save File
          const buffer = await workbook.xlsx.writeBuffer();
          saveAs(new Blob([buffer]), "Stock format.xlsx");
    }

    // const notSavedRecordsExcel = () => {
    //   const excel = new Excel()
    //   excel
    //   .addSheet('Stock Not Saved Records')
    //   .addColumns(exceldata)
    //   .addDataSource(notSavedRecords, { str2num: true })
    //   .saveAs('NotSavedRecords.xlsx')
    // }

    const notSavedRecordsExcel = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Stock Not Saved Records");
  
      // Define columns
      worksheet.columns = exceldata.map(col => ({ header: col.title, key: col.dataIndex, width: 20 }));
  
      // Populate data (Convert date format)
      notSavedRecords.forEach((record, index) => {
          worksheet.addRow({
              ...record,
              Date: record.Date ? moment(record.Date).format('YYYY-MM-DD') : '',
              sNo: index + 1
          });
      });
  
      // Apply Data Validation
       // Apply Data Validation
       worksheet.getColumn("TransactionType").eachCell((cell, rowNumber) => {
        if (rowNumber == 2) { // Skip header row
            cell.dataValidation = {
                type: "list",
                allowBlank: false,
                formulae: ['"Fresh Production,Repacking,Reprocessing,Stock Transfer,Reworking,Purchase Product,Lab Samples,Complements"'] // Modify values as per your requirement
            };
        }
    });

    worksheet.getColumn("StockType").eachCell((cell, rowNumber) => {
      if (rowNumber == 2) { // Skip header row
          cell.dataValidation = {
              type: "list",
              allowBlank: false,
              formulae: ['"Anticipated,Dummy,Sale Order,Super Dummy"'] // Modify values as per your requirement
          };
      }
  });

    worksheet.getColumn("Shift").eachCell((cell, rowNumber) => {
        if (rowNumber == 2) {
            cell.dataValidation = {
                type: "list",
                allowBlank: false,
                formulae: ['"General,DAY,NIGHT"']
            };
        }
    });

    worksheet.getColumn("ProductCategory").eachCell((cell, rowNumber) => {
      if (rowNumber == 2) {
          cell.dataValidation = {
              type: "list",
              allowBlank: false,
              formulae: ['"Over Count,Over Count Full Cut,Over Count Pull veined,For Weight,Under Count,Cut,RJ(Rejections),Damaged.P1-D,P2-D,P3-D,P4-D,P5-D,P6-D,Red Spot,Meat,jumble,GI,GII"']
          };
      }
  });
  
      // Save File
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), "NotSavedRecords.xlsx");
  };

    const onModalOk = () => {
      notSavedRecordsExcel()
      history.push('/fg-stock')
    }

    const onModalCancel = () => {
      notSavedRecordsExcel()
      setModalVisible(false)
    }

    return(
        <Card title='Stock' extra={<Link to=
            '/fg-stock'><span><Button type={'primary'} >View</Button> </span></Link>}>
            <Form form={form}>
            <Row gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                <Form.Item label = "">
                    <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={handleFileChange} />
                    <label style={{color:'blue',whiteSpace: 'nowrap'}} >Only csv & excel files are allowed</label>
                </Form.Item>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                    <Button type="primary"
                    onClick={handleUpload} 
                    loading={loading} disabled={!selectedFile}>Upload</Button>
                </Col>
                <Col>
                <Button
                type="default"
                style={{ color: "green" }}
                onClick={exportExcel}
                icon={<FileExcelFilled />}
                >
                    Sample Format for Excel Upload
                </Button>
                </Col>

            </Row>
                
            </Form>
            <Modal visible={modalVisible} footer={[<Button onClick={onModalOk}>OK</Button>]} onCancel={onModalCancel}>
              <>
              <p>Not Saved Records</p>
              {
                notSavedRecords.map(e => {
                  return(
                    <div>{e.SNo}</div>
                  )
                })
              }
              </>
            </Modal>
        </Card>
    )

}

export default StockExcelUpload